import { cn, emptyFragment } from '@execonline-inc/execonline-ui';
import { just } from 'maybeasy';
import { observer } from 'mobx-react';
import { findLink } from '../../LinkyLinky';
import { rootResourceStore } from '../../RootResourceStore';
import CopyrightNotice from './CopyrightNotice';
import Divider from './Divider';
import { CookiePreferencesLink, PrivacyPolicyLink, TermsOfUseLink } from './FooterLinks';

interface Props {
  className?: string;
}

// Matches the learner platform footer, without the sitemap and language switcher:
// Admin Studio has no sitemap page and is English only. className overrides the
// defaults (cn merges Tailwind classes), for example on the full-width builder pages.
function Footer({ className }: Props) {
  return just({})
    .assign('privacyLink', findLink('privacy')(rootResourceStore.links))
    .assign('termsLink', findLink('terms_and_conditions')(rootResourceStore.links))
    .map(({ privacyLink, termsLink }) => (
      <footer
        className={cn(
          'mt-16 flex flex-wrap items-center justify-center p-2.5 opacity-70',
          className,
        )}
        data-test-footer={true}
        role="contentinfo"
      >
        <CopyrightNotice />
        <Divider />
        <PrivacyPolicyLink href={privacyLink.href} />
        <Divider />
        <TermsOfUseLink href={termsLink.href} />
        <CookiePreferencesLink />
      </footer>
    ))
    .getOrElse(emptyFragment);
}

export default observer(Footer);
